import React, { PureComponent } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import config from '$config';

import GarageListPage from '../GarageListPage';
import GarageEditPage from '../GarageEditPage';
import GarageCreatePage from '../GarageCreatePage';
import GarageOperationsPage from '../GarageOperationPage/index';
import GarageCoveragePage from '../GarageCoveragePage/index';
import GarageDetailsPage from '../GarageDetailsPage/index';
import GarageUsersPage from '../GarageUsersPage/index';
import GarageUpdatesPage from '../GarageUpdatesPage/index';
import GarageSpecialitiesPage from '../GarageSpecialitiesPage';
import GarageCapacityPage from '../GarageCapacityPage';
import GarageImportListPage from '../GarageImportPage/GarageImportListPage';
import GarageImportUploadPage from '../GarageImportPage/GarageImportUploadPage';
import GarageImportJobPage from '../GarageImportPage/GarageImportJobPage';
import NotFoundPage from '../NotFoundPage';
import { isGarageCsvImportEnabled } from '../../utils/isGarageCsvImportEnabled';

class App extends PureComponent {
  render () {
    const isMotrio = config.segmentGroup === 'MOTRIO';
    const showGarageImport = isGarageCsvImportEnabled(config);

    return (
      <Router basename="/garages">
        <Switch>
          <Route exact path="/" component={GarageListPage} />
          <Route exact path="/new" component={GarageCreatePage} />
          {showGarageImport && <Route exact path="/imports" component={GarageImportListPage} />}
          {showGarageImport && <Route exact path="/imports/new/:mode(create|update)" component={GarageImportUploadPage} />}
          {showGarageImport && <Route exact path="/imports/:jobId" component={GarageImportJobPage} />}
          <Route exact path="/:garageId" component={GarageEditPage} />
          {isMotrio && (
            <Route
              exact
              path="/:garageId/:restrictedPage(operations|coverage|details|specialities|capacity)"
              render={({ match }) => <Redirect to={`/${match.params.garageId}`} />}
            />
          )}
          {!isMotrio && <Route exact path="/:garageId/operations" component={GarageOperationsPage} />}
          {!isMotrio && <Route exact path="/:garageId/coverage" component={GarageCoveragePage} />}
          {!isMotrio && <Route exact path="/:garageId/details" component={GarageDetailsPage} />}
          <Route exact path="/:garageId/users" component={GarageUsersPage} />
          <Route exact path="/:garageId/updates" component={GarageUpdatesPage} />

          {!isMotrio && <Route exact path="/:garageId/specialities" component={GarageSpecialitiesPage} />}
          {!isMotrio && <Route exact path="/:garageId/capacity" component={GarageCapacityPage} />}
          <Route path="*" component={NotFoundPage} />
        </Switch>
      </Router>
    );
  }
}

export default App;